import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createSlots as _createSlots, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08e0e0ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { style: {"padding":"8px"} }
const _hoisted_6 = { class: "pagination" }
const _hoisted_7 = {
  key: 0,
  class: "drawer-header-ar"
}
const _hoisted_8 = {
  key: 1,
  class: "drawer-header-all"
}
const _hoisted_9 = {
  key: 2,
  class: "drawer-header-ar"
}
const _hoisted_10 = {
  key: 3,
  class: "drawer-header-all"
}
const _hoisted_11 = { class: "label-form" }
const _hoisted_12 = { class: "label-form" }
const _hoisted_13 = { class: "label-form" }
const _hoisted_14 = { class: "label-form" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_16 = { class: "label-form" }
const _hoisted_17 = { class: "label-form" }
const _hoisted_18 = { class: "label-form" }
const _hoisted_19 = { class: "label-form" }
const _hoisted_20 = { class: "label-form" }
const _hoisted_21 = { class: "label-form" }
const _hoisted_22 = { class: "ant-upload-drag-icon" }
const _hoisted_23 = { class: "ant-upload-text" }
const _hoisted_24 = { class: "ant-upload-hint" }
const _hoisted_25 = {
  key: 0,
  class: "drawer-header-ar"
}
const _hoisted_26 = {
  key: 1,
  class: "drawer-header-all"
}
const _hoisted_27 = { class: "custom-header" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  class: "info-title",
  placeholder: "name"
}
const _hoisted_32 = {
  class: "info-title",
  placeholder: "name"
}
const _hoisted_33 = {
  class: "info-title",
  placeholder: "name"
}
const _hoisted_34 = { class: "label-form" }
const _hoisted_35 = {
  class: "info-title",
  placeholder: "name"
}
const _hoisted_36 = {
  class: "info-title",
  placeholder: "name"
}
const _hoisted_37 = { class: "info-title" }
const _hoisted_38 = { class: "label-form" }
const _hoisted_39 = { class: "label-form" }
const _hoisted_40 = { class: "label-form" }
const _hoisted_41 = { class: "label-form" }
const _hoisted_42 = { class: "label-form" }

import type { Rule } from "ant-design-vue/es/form";
import Swal from "sweetalert2";
import {
  EyeOutlined,
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
  InboxOutlined,
  ShopOutlined,
  SwapOutlined,
  QuestionCircleOutlined,
  SketchOutlined,
} from "@ant-design/icons-vue";
import LbrxLoaderSpinner from "../../components/LbrxLoaderSpinner.vue";
import { notification } from "ant-design-vue";
import { ingredientsService, productService, storeService } from "@/_services";
import type { UploadChangeParam, UploadFile } from "ant-design-vue";
import dayjs from "dayjs";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { and } from "@vuelidate/validators";
import { Empty } from "ant-design-vue";

interface ValidationStatus {
  [key: string]: string;
}

interface ValidationHelp {
  [key: string]: string;
}


import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  toRaw,
  computed,
  watch,
} from "vue";
import LoyaltyPopup from "../../components/forms/LoyaltyPopup.vue";
const __default__ = defineComponent({
  name: "StoreIndex",
  components: {
    LoyaltyPopup,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;

const modalWidth = ref(720);

const { locale } = useI18n();
const handleChangeFile = (info: UploadChangeParam) => {
  fileInfo.value = info.file;
};

const cancelUpdate = () => {
  form.name = "";
  form.photo = "";
  form.description = "";
};

const fileList = ref([]);
const fileInfo = ref<UploadFile | null>(null);
const handlePageChange = (newPage: any) => {
  currentPage.value = newPage;
  loading.value = true;

  //console.log('per page', perPage.value);
  //console.log('page', currentPage.value)

  storeService
    .searchWithFullParams("name", reactiveData.searchText, currentPage.value)
    .then((response) => {
      //console.log('data', response.data)
      reactiveData.data = response.data;
    })
    .catch((error) => {
      //console.log("error api : get products", error);
    })
    .finally(() => {
      loading.value = false;
    });
};

const handleChange = (info: UploadChangeParam) => {
  const file = info.file.originFileObj; // Access the actual file object
  //console.log('info', info.file);
  fileInfo.value = info.file;
};

function handleDrop(e: DragEvent) {
  //console.log(e);
}
const beforeUpload = () => {
  return false;
};

const files = ref<File | null>(null);

const addStore = () => {
  formRef.value
    .validate()
    .then(() => {
      let payload = {
        name: form.name,
        description: form.description,
        address: form.address,
        phone: form.phone,
        email: form.email,
      };
      const UserString = localStorage.getItem("user");
      if (UserString === null) {
        return;
      }
      const user = JSON.parse(UserString);
      form.active = user.account_id;

      let orderConfig = {
        start_number: form.ticketStartNumber,
        end_date: dayjs(form.ticketEndTime).format("HH:mm:ss"),
      };

      let config = {
        order_config: orderConfig,
      };

      const formData = new FormData();
      formData.append("name", form.name);
      formData.append("description", form.description);
      formData.append("address", form.address);
      formData.append("email", form.email);
      formData.append("phone", form.phone);
      formData.append("password", form.password);
      formData.append("account", form.active);
      formData.append("account_id", state.uid);
      formData.append("config", JSON.stringify(config));

      loading.value = true;
      storeService
        .add(formData)
        .then((res) => {
          reactiveData.data.push(res.store);
          showSuccessNotification(t("Pos.AddStore"));
          open.value = false;
        })
        .catch((err) => {
          resetFields();
          //console.log(err)
        })
        .finally(() => {
          loading.value = false;
        });
    })
    .catch((err: any) => {
      console.log(err);
    });
};
const loading = ref(false);

const handleLoading = (value: boolean) => {
  loading.value = value;
};
const router = useRouter();
const navigatePage = (link: string) => {
  router.push(link);
};
const searchInput = ref<HTMLInputElement | null>(null);
const { t } = useI18n();
const columns = [
  {
    title: t("Pos.identidier"),
    key: "uid",
    dataIndex: "uid",
  },
  {
    title: t("Pos.Name"),
    key: "name",
    dataIndex: "name",
    customFilterDropdown: false,
    onFilter: (value: string, record: any) =>
      record.name.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible: boolean) => {
      if (visible && !searchInput.value) {
        setTimeout(() => {
          const input = document.querySelector(
            ".ant-table-filter-dropdown input"
          );

          if (input instanceof HTMLInputElement) {
            searchInput.value = input;
            searchInput.value.focus();
          }
        }, 100);
      }
    },
  },

  {
    title: t("Pos.Description"),
    key: "description",
    dataIndex: "description",
  },
  {
    title: t("Pos.Phone"),
    key: "phone",
    dataIndex: "phone",
  },
  {
    title: t("Pos.Address"),
    key: "address",
    dataIndex: "address",
  },

  {
    title: t("Pos.Actions"),
    key: "actions",
    dataIndex: "actions",
  },
];

//form
const formRef = ref();
const addFormRef = ref();
const visible = ref<boolean>(false);

const reactiveData = reactive({
  data: [] as any[],
  action: "",
  totalPages: 0,
  searchText: "",
  searchedColumn: "",
});

const reactiveDataForAccounts = reactive({
  data: [] as any[],
  action: "",
  totalPages: 0,
  searchText: "",
  searchedColumn: "",
});

const resetFields = () => {
  formRef.value.resetFields();
};
const form = reactive({
  id: "",
  name: "",
  description: "",
  address: "",
  phone: "",
  email: "",
  account: "",
  username: "",
  password: "",
  searchTextInput: "",
  photo: "",
  active: "",
  maxQt: "",
  minQt: "",
  ticketStartNumber: 1,
  ticketEndTime: null as dayjs.Dayjs | null,
  displayEndTime: "",
});

const resetForm = () => {
  form.id = "";
  form.name = "";
  form.description = "";
  form.address = "";
  form.phone = "";
  form.email = "";
  form.username = "";
  form.password = "";
  form.active = "";
  form.account = "";
  form.displayEndTime = "";
  form.ticketStartNumber = 1;
  form.ticketEndTime = null;
};
const perPage = ref<number>(10);
const currentPage = ref<number>(1);
const rules: Record<string, Rule[]> = {
  name: [{ required: true, message: t("Pos.nameVerification") }],
  email: [
    {
      required: true,
      message: t("Pos.emailVerification"),
      trigger: "change",
    },
    {
      validator: (rule, value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          return Promise.reject(t("Pos.InvalidEmail"));
        }
        return Promise.resolve();
      },
      trigger: "change",
    },
  ],

  password: [{ required: true, message: t("Pos.passwordVerification") }],

  maxQt: [
    { required: true, message: t("Pos.RequiredField") },
    {
      validator: (_, value) => {
        if (!isNaN(value)) {
          return Promise.resolve();
        }
        return Promise.reject(t("Pos.numericField"));
      },
    },
  ],

  minQt: [
    { required: true, message: t("Pos.RequiredField") },
    {
      validator: (_, value) => {
        if (!isNaN(value)) {
          return Promise.resolve();
        }
        return Promise.reject(t("Pos.numericField"));
      },
    },
  ],
  ticketStartNumber: [{ required: true, message: t("Pos.RequiredField") }],
  ticketEndTime: [{ required: true, message: t("Pos.RequiredField") }],
};

const formatDate = (dateString: string) => {
  return dayjs(dateString);
};

const close = () => {
  resetFields();
  open.value = false;
};

const formatDisplayDate = (dateString: string) => {
  return dayjs(dateString).format("DD-MM-YYYY HH:mm:ss");
};

//drawer

const open = ref<boolean>(false);

const showAddDrawer = (state: boolean) => {
  updateModalWidth();
  open.value = state;
  reactiveData.action = "add";
  resetForm();
};

const afterOpenChange = (bool: boolean) => {
  //console.log('open', bool);
};

const showDrawer = (record: any) => {
  updateModalWidth();
  open.value = true;
  getStoreById(record.id);
  resetForm();
  reactiveData.action = "update";
};

const showDisplayDrawer = (record: any) => {
  updateModalWidth();
  openDisplay.value = true;
  getStoreById(record.id);
  resetForm();
  reactiveData.action = "view";
};

const openAdd = ref<boolean>(false);

const showSuccessNotification = (message: string) => {
  notification.success({
    message: message,
    duration: 3,
    top: "80px",
    style: {
      backgroundColor: "#bfffca8a",
      color: "white",
    },
  });
};

const getStore = () => {
  loading.value = true;
  storeService
    .getMyStores()
    .then((res) => {
      reactiveData.data = res.data;
      reactiveData.totalPages = res.meta.total;
    })
    .catch((error) => {
      // console.log("error api : get store", error);
    })
    .finally(() => {
      loading.value = false;
    });
};

const getStoresForFilter = (searchText: string) => {
  loading.value = true;
  // Adjust this part according to your API call
  storeService
    .searchWithFullParams("name", searchText, currentPage.value)
    .then((res) => {
      reactiveData.data = res.data;
      reactiveData.totalPages = res.meta.total;
    })
    .catch((error) => {
      // console.log("error api : get warehouses", error);
    })
    .finally(() => {
      loading.value = false;
    });
};

const getStoreById = (id: string) => {
  loading.value = true;
  storeService
    .show(id)
    .then((res) => {
      form.name = res.data.name;
      form.description = res.data.description;
      form.address = res.data.address;
      form.phone = res.data.phone;
      form.email = res.data.email;
      form.id = res.data.id;
      form.photo = res.data.logo;
      form.active = res.data.account_id;

      let config = res.data.config ? JSON.parse(res.data.config) : "";
      const orderConfig = config.order_config ? config.order_config : "";
      form.ticketStartNumber = orderConfig.start_number;
      form.ticketEndTime = orderConfig.end_date
        ? dayjs(orderConfig.end_date, "HH:mm:ss")
        : null;

      form.displayEndTime = config.order_config
        ? dayjs(form.ticketEndTime).format("HH:mm:ss")
        : "";

      loading.value = false;
    })
    .catch((error) => {
      loading.value = false;

      // console.error('Error fetching categories:', error);
    });
};

const handleSearch = (
  selectedKeys: any[],
  confirm: () => void,
  dataIndex: string
) => {
  confirm();
  getStoresForFilter(selectedKeys[0]);
  reactiveData.searchedColumn = dataIndex;
};

const handleReset = (clearFilter: (arg: any) => void) => {
  clearFilter({ confirm: true });
  reactiveData.searchText = "";
  getStore();
};

const updateStore = (id: string) => {
  formRef.value
    .validate()
    .then(() => {
      const UserString = localStorage.getItem("user");
      if (UserString === null) {
        return;
      }
      const user = JSON.parse(UserString);
      form.active = user.account_id;

      let orderConfig = {
        start_number: form.ticketStartNumber,
        end_date: dayjs(form.ticketEndTime).format("HH:mm:ss"),
      };

      let config = {
        order_config: orderConfig,
      };

      loading.value = true;
      storeService
        .updateStore(
          id.toString(),
          form.name,
          form.description,
          form.address,
          form.email,
          form.phone,
          form.password,
          form.active,
          fileInfo.value,
          JSON.stringify(config)
        )
        .then((res) => {
          localStorage.setItem("store", JSON.stringify(res.data));
          reactiveData.data = reactiveData.data.map((el) =>
            el.id !== id ? el : res.data
          );
          showSuccessNotification(t("Pos.UpdateStore"));
        })
        .catch((err) => {
          // console.log(err)
        })
        .finally(() => {
          open.value = false;
          loading.value = false;
        });
    })
    .catch((err: any) => {
      console.log(err);
    });
};

const deleteStore = (id: string) => {
  loading.value = true;
  storeService
    .delete(id)
    .then((res) => {
      reactiveData.data = reactiveData.data.filter((e) => e.id !== id);
      showSuccessNotification(t("Pos.DeleteStore"));
    })
    .catch((err) => {
      //  console.log(err)
    })
    .finally(() => {
      // console.log('finish')
      loading.value = false;
    });
};

const openDisplay = ref<boolean>(false);
const afterOpenShowChange = (bool: boolean) => {
  // console.log('open', bool);
};

const textDirection = computed(() => {
  return locale.value === "ar" ? "rtl" : "ltr";
});
const showDeletePopup = (record: any) => {
  Swal.fire({
    title: t("Pos.TitleDeleteStore"),
    text: t("Pos.TextDeleteStore"),
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#fc8019",
    confirmButtonText: t("Pos.Delete"),
    cancelButtonText: t("Pos.Cancel"),
    cancelButtonColor: "#d33",
    customClass: {
      popup: "swal2-popup",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      deleteStore(record.id);
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      //  console.log("cancel delete ");
    }
  });
};

const updateModalWidth = () => {
  modalWidth.value = window.innerWidth <= 1200 ? window.innerWidth : 720;
};

//transfer modal

const state = reactive({
  store:{} as any,
  uid: "",
  sender_store: [] as any[],
  target_store: [] as any[],
  fetchingTargetStore: false,

  receiver_store: [] as any[],
  destination_store: [] as any[],
  fetchingDestinationStore: false,

  target_store_id: "",
  itemType: "",

  itemValues: [] as any[],
  items: [] as any[],
  fetchingItems: false,

  qtArray: [] as any[],
});
const openTransferModal = ref<boolean>(false);

const showTransferModal = () => {
  openTransferModal.value = true;
};

const handleCancel = () => {
  transferFormRef.value.resetFields();
  openTransferModal.value = false;
  state.qtArray = [];
  state.sender_store = [];
  state.destination_store = [];
  state.target_store = [];
  state.destination_store = [];
  state.itemValues = [];
  state.items = [];
  state.fetchingDestinationStore = false;
  state.fetchingTargetStore = false;
  state.fetchingItems = false;
};

const transferFormRef = ref();

const transferForm = reactive({
  id: "",
  targetStoreId: "",
  destinationStoreId: "",
  item_type: "",
  items: [] as any[],
  quantities: [] as any[],

  target_store: state.sender_store,
  destination_store: state.receiver_store,
});

const transferRules: Record<string, Rule[]> = {};

//target store fetch
let debonceTimerTraget: ReturnType<typeof setTimeout> | null = null;
const fetchTarget = (value: any) => {
  //disable fetching when the input is empty
  if (value === "") {
    return;
  }

  state.target_store = [];

  state.fetchingTargetStore = true;

  //clear previous timer
  if (debonceTimerTraget) {
    clearTimeout(debonceTimerTraget);
  }

  //fetch stores

  debonceTimerTraget = setTimeout(() => {
    storeService
      .searchMyStoresWithoutPagination("name", value)
      .then((res) => {
        const data = res.data.map((store: { name: any; id: any }) => ({
          label: `${store.name}`,
          value: store.id,
        }));

        state.target_store = data;

        state.fetchingTargetStore = false;

        console.log("state.target_store", state.target_store);
      })
      .catch((error) => {
        console.log("error fetching stores", error);
      });
  }, 700);
};

watch(state.sender_store, () => {
  state.target_store = [];
  state.fetchingTargetStore = false;
});

const selectedSenderStore = (value: any, option: any) => {
  state.target_store_id = value;

  state.destination_store = state.target_store.filter(
    (store) => store.value !== value
  );
  console.log("neww", state.destination_store);
  if (state.destination_store.length === 0) {
    transferForm.destinationStoreId = "";
  }
};

//destination store fetch
let debonceTimerDestination: ReturnType<typeof setTimeout> | null = null;
const fetchDestination = (value: any) => {
  //disable fetching when the input is empty
  if (value === "") {
    return;
  }

  state.destination_store = [];

  state.fetchingDestinationStore = true;

  //clear previous timer
  if (debonceTimerDestination) {
    clearTimeout(debonceTimerDestination);
  }

  //fetch stores

  debonceTimerTraget = setTimeout(() => {
    storeService
      .searchMyStoresWithoutPagination("name", value)
      .then((res) => {
        const data = res.data.map((store: { name: any; id: any }) => ({
          label: `${store.name}`,
          value: store.id,
        }));

        state.destination_store = data;

        state.fetchingDestinationStore = false;
      })
      .catch((error) => {
        console.log("error fetching stores", error);
      });
  }, 700);
};

watch(state.receiver_store, () => {
  state.destination_store = [];
  state.fetchingDestinationStore = false;
});

const handleTypeChange = (selectedItem: any) => {
  state.itemType = "";
  state.itemValues = [];
  state.items = [];
  state.fetchingItems = false;
  if (selectedItem === "product") {
    state.itemType = "product";
  } else if (selectedItem === "ingredient") {
    state.itemType = "ingredient";
  }
};

let debounceTimerItems: ReturnType<typeof setTimeout> | null = null;

const fetchItems = (value: any) => {
  //disable fetching when the input is empty
  if (value === "") {
    return;
  }

  state.items = [];

  state.fetchingItems = true;

  //clear previous timer
  if (debounceTimerItems) {
    clearTimeout(debounceTimerItems);
  }

  //fetch products
  if (state.itemType === "product") {
    debounceTimerItems = setTimeout(() => {
      productService
        .getProductsByName(value)
        .then((res) => {
          const data = res.data.map((product: { name: any; id: any }) => ({
            label: `${product.name} `,
            value: product.id,
          }));

          state.items = data;

          console.log("products", state.items);

          state.fetchingItems = false;

          console.log("state.itemValues : ", state.itemValues);
        })
        .catch((error) => {
          console.log("error fetching users", error);
        });
    }, 700);
  } else if (state.itemType === "ingredient") {
    debounceTimerItems = setTimeout(() => {
      ingredientsService
        .filterWithoutPagination("name", value)
        .then((res) => {
          const data = res.data.map((product: { name: any; id: any }) => ({
            label: `${product.name} `,
            value: product.id,
          }));

          state.items = data;

          console.log("ingredients", state.items);

          state.fetchingItems = false;

          console.log("state.itemValues : ", state.itemValues);
        })
        .catch((error) => {
          console.log("error fetching users", error);
        });
    }, 700);
  }
};

watch(state.itemValues, () => {
  state.items = [];
  state.fetchingItems = false;
});

const handleMultiChange = (value: any[]) => {
  console.log("value", value);
  state.qtArray = state.qtArray.filter((item) => value.includes(item.key));
  if (value) {
    value.forEach((itemId) => {
      console.log("itemId", itemId);
      const selectedItem = state.items.find(
        (option: any) => option.value === itemId.value
      );
      if (
        selectedItem &&
        !state.qtArray.some((item) => item.item_id === itemId.value)
      ) {
        state.qtArray.push({
          item_id: itemId.key,
          name: selectedItem.label,
          quantity: "",
        });
      }
    });
  }
  console.log("qt array", state.qtArray);
};

const validationStatus = ref<ValidationStatus>({});

const validationHelp = ref<ValidationHelp>({});

const getValidatingStatus = (id: any, fieldType: string) => {
  return validationStatus.value[`${fieldType}_${id}`] || "";
};

const getValidatingHelp = (id: any, fieldType: string) => {
  return validationHelp.value[`${fieldType}_${id}`] || "";
};

function isNum(value: any) {
  return !isNaN(parseFloat(value)) && isFinite(value);
}

const transfer = () => {
  transferFormRef.value
    .validate()
    .then(() => {
      let items: any[] = [];
      let quantities: string[] = [];
      let hasErrors = false;
      state.qtArray.forEach((item) => {
        const qtInput = document.getElementById(
          `qt_${item.item_id}`
        ) as HTMLInputElement;

        if (qtInput.value === "") {
          console.log("here : ", item.item_id, qtInput);
          validationStatus.value[`qt_${item.item_id}`] = "error";
          validationHelp.value[`qt_${item.item_id}`] = t("Pos.RequiredField");
          hasErrors = true;
        } else if (!isNum(qtInput.value)) {
          console.log("is number", item.item_id, qtInput);
          validationStatus.value[`qt_${item.item_id}`] = "error";
          validationHelp.value[`qt_${item.item_id}`] = t("Pos.numericField");
          hasErrors = true;
        } else {
          console.log("success");
          validationStatus.value[`qt_${item.item_id}`] = "";
          validationHelp.value[`qt_${item.item_id}`] = "";

          quantities.push(qtInput.value);
          items.push(item.item_id);
        }

        console.log("items", items);
        console.log("quantities", quantities);
      });
    })
    .catch((error: any) => {
      console.log("error validation");
    });
};

const getUserData = () => {
  const store = localStorage.getItem("user");
  if (store) {
    const parsedStore = JSON.parse(store);
    state.uid = parsedStore.account_id;
  }
};


//loayalty
const openLoyalty=ref(false);
const showLoyaltyPopup=(record:any)=>{
  openLoyalty.value=true;
  state.store=record;

}

const closeLoyaltyPopup=()=>{
  openLoyalty.value=false;
  state.store={} as any;
}

onMounted(async () => {
  updateModalWidth;
  window.addEventListener("resize", updateModalWidth);
  await getUserData();
  await getStore();
});

return (_ctx: any,_cache: any) => {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_time_picker = _resolveComponent("a-time-picker")!
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(LbrxLoaderSpinner, {
        "is-loaded": !loading.value
      }, null, 8, ["is-loaded"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_breadcrumb, {
        style: {"margin":"16px 0"},
        class: _normalizeClass({ 'is-rtl': textDirection.value === 'rtl' })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_breadcrumb_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (navigatePage('/'))),
            class: "breadcrumb-icon"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Pos.Home")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Pos.Store")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_row, { gutter: 16 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: { span: 24 },
            sm: { span: 12 },
            md: { span: 12 },
            lg: { span: 12 },
            xl: { span: 12 },
            xxl: { span: 12 },
            class: "action-btn-container"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                class: "add-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showAddDrawer(true)))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_unref(ShopOutlined))
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("Pos.Add")) + " ", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_table, {
        class: "table-container",
        columns: columns,
        "data-source": reactiveData.data,
        pagination: false
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.key == 'actions')
            ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("Pos.View")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        class: "view-btn",
                        onClick: () => showDisplayDrawer(record)
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(EyeOutlined))
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("Pos.Edit")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: () => showDrawer(record)
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(EditOutlined))
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("Pos.Delete")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        danger: "",
                        onClick: ($event: any) => (showDeletePopup(record))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(DeleteOutlined))
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("Pos.Loyalty")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        class: "variant-btn",
                        type: "primary",
                        onClick: ($event: any) => (showLoyaltyPopup(record))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(SketchOutlined))
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (column.key === 'uid')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "#" + _toDisplayString(record.uid), 1))
            : _createCommentVNode("", true),
          (column.key === 'description')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (record.description != 'null')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(record.description), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4))
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'created_at' || column.key === 'updated_at')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(_toDisplayString(formatDisplayDate(record[column.key])), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        customFilterDropdown: _withCtx(({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          column,
        }) => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_input, {
              ref_key: "searchInput",
              ref: searchInput,
              placeholder: `Search ${column.dataIndex}`,
              value: selectedKeys[0],
              style: {"width":"188px","margin-bottom":"8px","display":"block"},
              onChange: 
              (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
            ,
              onPressEnter: ($event: any) => (handleSearch(selectedKeys, confirm, column.dataIndex))
            }, null, 8, ["placeholder", "value", "onChange", "onPressEnter"]),
            _createVNode(_component_a_button, {
              type: "primary",
              size: "small",
              style: {"width":"90px","margin-right":"8px"},
              onClick: ($event: any) => (handleSearch(selectedKeys, confirm, column.dataIndex))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(SearchOutlined))
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_unref(t)("Pos.Search")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              size: "small",
              style: {"width":"90px"},
              onClick: ($event: any) => (handleReset(clearFilters))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("Pos.Reset")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        customFilterIcon: _withCtx(({ filtered }) => [
          _createVNode(_unref(SearchOutlined), {
            style: _normalizeStyle({ color: filtered ? '#108ee9' : undefined })
          }, null, 8, ["style"])
        ]),
        _: 1
      }, 8, ["data-source"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_a_pagination, {
          class: "paginationArrows",
          current: currentPage.value,
          "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((currentPage).value = $event)),
          total: reactiveData.totalPages,
          onChange: handlePageChange,
          "default-page-size": perPage.value
        }, null, 8, ["current", "total", "default-page-size"])
      ]),
      _createVNode(_component_a_drawer, {
        open: open.value,
        "onUpdate:open": _cache[14] || (_cache[14] = ($event: any) => ((open).value = $event)),
        class: "custom-class",
        "root-class-name": "root-class-name",
        "root-style": { color: 'blue' },
        style: {"color":"red"},
        title: null,
        placement: _unref(locale) === 'ar' ? 'left' : 'right',
        width: modalWidth.value,
        "body-style": { paddingBottom: '80px' },
        onAfterOpenChange: afterOpenChange,
        onClose: resetFields
      }, {
        title: _withCtx(() => [
          (_unref(locale) === 'ar' && reactiveData.action == 'add')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)("Pos.AddStoreDrawer")), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(locale) !== 'ar' && reactiveData.action == 'add')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)("Pos.AddStoreDrawer")), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(locale) === 'ar' && reactiveData.action == 'update')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)("Pos.UpdateStoreDrawer")), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(locale) !== 'ar' && reactiveData.action == 'update')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)("Pos.UpdateStoreDrawer")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass({ 'is-rtl': textDirection.value === 'rtl' })
          }, [
            (reactiveData.action == 'update')
              ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (updateStore(form.id)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("Pos.Update")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      danger: "",
                      onClick: close
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("Pos.Cancel")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (reactiveData.action == 'add')
                ? (_openBlock(), _createBlock(_component_a_space, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: addStore
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("Pos.Add")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        danger: "",
                        onClick: close
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("Pos.Cancel")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_space, { key: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        danger: "",
                        onClick: close
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("Pos.Cancel")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
          ], 2)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form,
            rules: rules,
            layout: "vertical",
            class: _normalizeClass({ 'is-rtl': textDirection.value === 'rtl' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "name" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)("Pos.Name")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: form.name,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.name) = $event)),
                            disabled: 
                  reactiveData.action !== 'add' &&
                  reactiveData.action !== 'update'
                ,
                            placeholder: _unref(t)('Pos.Name'),
                            class: "input-form"
                          }, null, 8, ["value", "disabled", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "address" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)("Pos.Address")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: form.address,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.address) = $event)),
                            disabled: 
                  reactiveData.action !== 'add' &&
                  reactiveData.action !== 'update'
                ,
                            placeholder: _unref(t)('Pos.Address'),
                            class: "input-form"
                          }, null, 8, ["value", "disabled", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "email" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)("Pos.Email")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: form.email,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.email) = $event)),
                            placeholder: _unref(t)('Pos.Email'),
                            disabled: 
                  reactiveData.action !== 'add' &&
                  reactiveData.action !== 'update'
                ,
                            class: "input-form"
                          }, null, 8, ["value", "placeholder", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "description" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)("Pos.Description")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: form.description,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.description) = $event)),
                            disabled: 
                  reactiveData.action !== 'add' &&
                  reactiveData.action !== 'update'
                ,
                            placeholder: _unref(t)('Pos.Description'),
                            class: "input-form"
                          }, null, 8, ["value", "disabled", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_15,
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "phone" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)("Pos.Phone")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: form.phone,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.phone) = $event)),
                            placeholder: _unref(t)('Pos.Phone'),
                            class: "input-form"
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "password" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)("Pos.Password")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input_password, {
                            value: form.password,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.password) = $event)),
                            visible: visible.value,
                            "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((visible).value = $event)),
                            placeholder: _unref(t)('Pos.Password'),
                            class: "input-form"
                          }, null, 8, ["value", "visible", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    class: "title-txt-wrapper"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)("Pos.ticketConfiguration")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: { span: 24 },
                    sm: { span: 24 },
                    md: { span: 12 },
                    lg: { span: 12 },
                    xl: { span: 12 },
                    xxl: { span: 12 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "ticketStartNumber" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)("Pos.startNumber")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input_number, {
                            value: form.ticketStartNumber,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.ticketStartNumber) = $event)),
                            min: 1,
                            class: "input-form full-width"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: { span: 24 },
                    sm: { span: 24 },
                    md: { span: 12 },
                    lg: { span: 12 },
                    xl: { span: 12 },
                    xxl: { span: 12 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "ticketEndTime" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)("Pos.endTime")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_time_picker, {
                            value: form.ticketEndTime,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((form.ticketEndTime) = $event)),
                            class: "full-width"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, null, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)("Pos.Photo")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_upload_dragger, {
                            fileList: fileList.value,
                            "onUpdate:fileList": _cache[12] || (_cache[12] = ($event: any) => ((fileList).value = $event)),
                            name: "file",
                            multiple: false,
                            "max-count": 1,
                            onChange: handleChangeFile,
                            onDrop: handleDrop,
                            "before-upload": beforeUpload
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_22, [
                                _createVNode(_unref(InboxOutlined))
                              ]),
                              _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(t)("Pos.dropTitle1")), 1),
                              _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(t)("Pos.dropTitle2")), 1)
                            ]),
                            _: 1
                          }, 8, ["fileList"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "class"])
        ]),
        _: 1
      }, 8, ["open", "placement", "width"]),
      _createVNode(_component_a_drawer, {
        open: openDisplay.value,
        "onUpdate:open": _cache[15] || (_cache[15] = ($event: any) => ((openDisplay).value = $event)),
        class: "custom-class",
        "root-class-name": "root-class-name",
        title: null,
        placement: _unref(locale) === 'ar' ? 'left' : 'right',
        width: modalWidth.value,
        onAfterOpenChange: afterOpenShowChange
      }, {
        title: _withCtx(() => [
          (_unref(locale) === 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)("Pos.DetailsStoreDrawer")), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(locale) !== 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)("Pos.DetailsStoreDrawer")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_a_space)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref_key: "addFormRef",
            ref: addFormRef,
            model: form,
            layout: "vertical",
            class: _normalizeClass({ 'is-rtl': textDirection.value === 'rtl' })
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)("Pos.GeneralInformations")), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", {
                          class: "info-title",
                          disabled: 
                  reactiveData.action !== 'add' &&
                  reactiveData.action !== 'update'
                ,
                          placeholder: "name"
                        }, _toDisplayString(_unref(t)("Pos.FullName")) + " :", 9, _hoisted_28),
                        _createTextVNode(" " + _toDisplayString(form.name), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", {
                          class: "info-title",
                          disabled: 
                  reactiveData.action !== 'add' &&
                  reactiveData.action !== 'update'
                ,
                          placeholder: "name"
                        }, _toDisplayString(_unref(t)("Pos.Description")) + " :", 9, _hoisted_29),
                        (form.description !== 'null')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(form.description), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(t)("Pos.Address")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(form.address), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)("Pos.Email")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(form.email), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(t)("Pos.Phone")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(form.phone), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(t)("Pos.ticketConfiguration")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(t)("Pos.startNumber")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(form.ticketStartNumber), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(t)("Pos.endTime")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(form.displayEndTime), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (form.photo !== null)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, [
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(t)("Pos.Photo")) + " :", 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 16 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { name: "photo" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_image, {
                                width: 200,
                                src: form.photo
                              }, null, 8, ["src"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model", "class"])
        ]),
        _: 1
      }, 8, ["open", "placement", "width"]),
      _createVNode(_component_a_modal, {
        open: openTransferModal.value,
        "onUpdate:open": _cache[20] || (_cache[20] = ($event: any) => ((openTransferModal).value = $event)),
        onCancel: handleCancel
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            key: "submit",
            type: "primary",
            onClick: transfer
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Pos.Confirm")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            key: "back",
            onClick: handleCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Pos.Cancel")), 1)
            ]),
            _: 1
          })
        ]),
        title: _withCtx(() => [
          _createElementVNode("p", {
            class: _normalizeClass({ 'is-rtl': textDirection.value === 'rtl' })
          }, _toDisplayString(_unref(t)("Pos.TransferItems")), 3)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref_key: "transferFormRef",
            ref: transferFormRef,
            model: transferForm,
            rules: transferRules,
            layout: "vertical",
            class: _normalizeClass({ 'is-rtl': textDirection.value === 'rtl' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "target_store" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)("Pos.From")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: state.sender_store,
                            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((state.sender_store) = $event)),
                            "show-search": "",
                            "default-active-first-option": false,
                            "filter-option": false,
                            onSearch: fetchTarget,
                            options: state.target_store,
                            onSelect: selectedSenderStore
                          }, _createSlots({ _: 2 }, [
                            (state.fetchingTargetStore)
                              ? {
                                  name: "notFoundContent",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_a_spin, { size: "small" })
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["value", "options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "destination_store" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(t)("Pos.To")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: state.receiver_store,
                            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((state.receiver_store) = $event)),
                            "show-search": "",
                            "default-active-first-option": false,
                            "filter-option": false,
                            onSearch: fetchDestination,
                            options: state.destination_store,
                            disabled: state.sender_store.length === 0,
                            class: "store-select"
                          }, _createSlots({ _: 2 }, [
                            (state.fetchingDestinationStore)
                              ? {
                                  name: "notFoundContent",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_a_spin, { size: "small" })
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["value", "options", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "item_type" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(t)("Pos.Typeofmerchandise")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: transferForm.item_type,
                            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((transferForm.item_type) = $event)),
                            "show-search": "",
                            "option-filter-prop": 'label',
                            onChange: handleTypeChange,
                            disabled: 
                  state.receiver_store.length === 0 ||
                  state.sender_store.length === 0
                
                          }, {
                            notFoundContent: _withCtx(() => [
                              _createVNode(_component_a_empty, {
                                description: _unref(t)('Pos.NoData'),
                                image: _unref(simpleImage)
                              }, null, 8, ["description", "image"])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, {
                                value: "product",
                                label: _unref(t)('Pos.Product')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)("Pos.Product")), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_a_select_option, {
                                value: "ingredient",
                                label: _unref(t)('Pos.Ingredient')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)("Pos.Ingredient")), 1)
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }, 8, ["value", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "items" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(t)("Pos.Items")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: state.itemValues,
                            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((state.itemValues) = $event)),
                            mode: "multiple",
                            "label-in-value": "",
                            placeholder: _unref(t)('Pos.Item'),
                            style: {"width":"100%"},
                            "filter-option": false,
                            "not-found-content": state.fetchingItems ? undefined : null,
                            options: state.items,
                            onSearch: fetchItems,
                            onChange: handleMultiChange,
                            disabled: 
                  state.receiver_store.length === 0 ||
                  state.sender_store.length === 0 ||
                  !transferForm.item_type
                
                          }, _createSlots({ _: 2 }, [
                            (state.fetchingItems)
                              ? {
                                  name: "notFoundContent",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_a_spin, { size: "small" })
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["value", "placeholder", "not-found-content", "options", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.qtArray, (item) => {
                return (_openBlock(), _createBlock(_component_a_row, {
                  key: item,
                  gutter: 16
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: { span: 24 },
                      sm: { span: 24 },
                      md: { span: 9 },
                      lg: { span: 9 },
                      xl: { span: 9 },
                      xxl: { span: 9 }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_a_col, {
                      xs: { span: 24 },
                      sm: { span: 24 },
                      md: { span: 15 },
                      lg: { span: 15 },
                      xl: { span: 15 },
                      xxl: { span: 15 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          "has-feedback": "",
                          name: 'qt_' + item.item_id,
                          "validate-status": getValidatingStatus(item.item_id, 'qt'),
                          help: getValidatingHelp(item.item_id, 'qt')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              id: 'qt_' + item.item_id,
                              placeholder: _unref(t)('Pos.Quantity'),
                              value: item.quantity,
                              "onUpdate:value": ($event: any) => ((item.quantity) = $event),
                              class: "input-form"
                            }, null, 8, ["id", "placeholder", "value", "onUpdate:value"])
                          ]),
                          _: 2
                        }, 1032, ["name", "validate-status", "help"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["model", "class"])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _createVNode(LoyaltyPopup, {
      open: openLoyalty.value,
      store: state.store,
      onCloseLoyaltyPopup: closeLoyaltyPopup,
      onRefreshStores: getStore,
      onLoading: handleLoading
    }, null, 8, ["open", "store"])
  ], 64))
}
}

})